import React, { Component } from 'react';

export default class Highlights extends Component {

	render() {
		return(
			<div className='row border' id='highlights'>
				<div className='col-md-2'>
					<h2>100+ Unique<br />Placement Opportunities</h2>
					<ul>
						<li>
							Tailored Marketing Campaigns
						</li>
						<li>
							Captivating Lifestyle Images
						</li>
					</ul>
				</div>
				<div className='col-md-2'>
					<h2>17%+ Average<br />Conversion Rate</h2>
					<ul>
						<li>
							20+ Top Converting Verticals
						</li>
						<li>
							15% Mobile Conversion
						</li>
					</ul>
				</div>
				<div className='col-md-2'>
					<h2>Guaranteed<br />Return On Ad Spend</h2>
					<ul>
						<li>
							Available With Most Placements
						</li>
						<li>
							10:1 ROAS On Top Verticals
						</li>
					</ul>
				</div>
				<div className='col-md-2'>
					<h2>Strict Branding &amp;<br />Promotional Messaging</h2>
					<ul>
						<li>
							No UGC Allowed
						</li>
						<li>
							Personalized Merchant Page
						</li>
					</ul>
				</div>
				<div className='col-md-2'>
					<h2>Powerful Mobile<br />Marketing Strategy</h2>
					<ul>
						<li>
							55% Overall Mobile Traffic
						</li>
						<li>
							15% Average Mobile Conversion
						</li>
					</ul>
				</div>
				<div className='col-md-2'>
					<h2>1 Million+<br />Newsletter Subscribers</h2>
					<ul>
						<li>
							13% Email Open Rate
						</li>
						<li>
							5% Newsletter Conversion
						</li>
					</ul>
				</div>
			</div>
		);
	}
}